import React, { useEffect, useState } from 'react'
import { Badge, Button, Card, Image } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import Skeleton from '@material-ui/lab/Skeleton';
import Aos from 'aos'
import 'aos/dist/aos.css'
import GitHubIcon from '@material-ui/icons/GitHub';
import { OpenInNewRounded } from '@material-ui/icons'

export const Project = ({ description, features, git, status, link, stack, title, id, image }) => {
    
    const [loaded, setLoaded] = useState(false)
    useEffect(()=>{
        Aos.init({})
    },[])
    
    return (
        <Card data-aos="flip-up" data-aos-duration="3000" className='py-5 px-5 border-0' style={{ backgroundColor:"rgb(31,31,31)", borderRadius:"2rem", height:'100%', boxShadow:"1px 3px 6px rgb(53, 53, 53), 0px 0px rgb(53, 53, 53)" }} sm={12} id='card-project'>
            <>
                {!loaded && typeof window==="object" && window.innerWidth>500 
                ?
                <>
                <Skeleton className='mb-5 mx-auto' animation="wave" width={350} height={180} style={{ borderRadius:"1rem", color:"rgba(255,255,255,.70)", backgroundColor:"rgba(255,255,255,.70)" }} variant="rect" /> 
                <img src={image} onLoad={() => setLoaded(true)} alt="Project Thumbnail" style={{ display:"none" }} />
                </>
                :<Image src={image} style={{ width:'100%', border:'0.5px ridge rgb(219,219,219)', borderRadius:"1rem" }} className='image border-0 mb-4' />
                }
            </>
            <Card.Title>
                {title}
                <Badge variant=
                {status==='Upcoming' 
                        ? 'warning' 
                        : status.split(' ')[status.split(' ').length-1]==='star' 
                        ? 'primary' 
                        : 'success'}
                        className='p-1 mx-2' 
                >{status}</Badge>
            </Card.Title>
            <div style={{ textAlign:'left' }} className='mb-2' >
                <b>Description:</b>
                {description.map(d=>(
                <li key={description.indexOf(d)}>{d}</li>
            ))}</div>
            <div style={{ textAlign:'left' }} className='mb-2' id='features'>
                <b>Features:</b>
                {features.map(f=>(
                    <li key={features.indexOf(f)}>{f}</li>
                ))}
            </div>
            <div style={{ textAlign:'left' }} className='mb-2' id='stack'>
                <Badge variant='success' style={{ fontSize:14 }} >Tech Stack:</Badge>
                {stack.map(s=>(
                    <li key={stack.indexOf(s)}>{s}</li>
                ))}
            </div>
            {typeof window==='object' && window.innerWidth>500 ? 
            <>
            <div style={{ textAlign:'left', display:'flex', flexDirection:'column' }} className='mb-2' id='git' >
                <Badge variant="secondary" style={{ fontSize:"1rem", width:"max-content" }} className="my-2">GitHub: </Badge>
                <a href={git.slice(0,5)==='https' ? git : '/projects'} rel="noreferrer" target='_blank' style={{ textDecoration:'underline' }}>{git}</a>
            </div>
            <div style={{ textAlign:'left', display:'flex', flexDirection:'column' }} className='mb-2' id='link' >
                <Badge variant="info" style={{ fontSize:"1rem", width:"max-content" }} className="my-2">Project link: </Badge>
                <a rel="noreferrer" target='_blank' href={link==='Upcoming' || link==='N/A' ? '/projects' : link} style={{ textDecoration:'underline' }}>{link}</a>
            </div>
            </>
            :
            <div style={{ backgroundColor:'rgb(31,31,31)' }} className='mx-auto d-flex list-group-item' >
                <a target="_blank" rel="noopener noreferrer" href={git.slice(0,5)==='https' ? git : `/projects/${id}`} style={{ flex:1, width:'100%' }}>
                    <Button variant='dark' style={{ backgroundColor:'rgb(31,31,31)', border:"1px solid rgb(102,102,102)", width:"90%" }}>
                        <GitHubIcon style={{ backgroundColor:'rgb(31,31,31)' }} />
                        <b className='ml-2'>GitHub</b>
                    </Button>
                </a>
                {link!=='N/A' && link!=='Upcoming' && 
                <a target="_blank" rel="noopener noreferrer" href={link!=='N/A' && link!=='Upcoming' && link} style={{ flex:1, width:'100%' }}>
                    <Button variant='dark' style={{ backgroundColor:'rgb(31,31,31)', border:"1px solid rgb(102,102,102)", width:"90%" }}>
                        <OpenInNewRounded style={{ backgroundColor:'rgb(31,31,31)' }} />
                        <b className='ml-2'>View</b>
                    </Button>
                </a>}
            </div>}
            <Button variant='dark' className='view mt-3' style={{ textAlign:"center !important", borderRadius:"150px" }}>
                <Link className='view' style={{ textAlign:'center', backgroundColor:'#343a40 !important' }} to={`/projects/${id}`} >
                    <b className='mx-auto' style={{ backgroundColor:"#343a40 !important" }}>View Project & Details</b>
                </Link>
            </Button>
        </Card>
    )
}
